import { Game } from "@aura-frontend/omnibus-az-client";

import { getEventTimes } from "@/utils/eventUtils";

import { formatGameStartTime } from "../../../utils/formatGameStartTime";

type BullpenModeInfoProps = {
  game: Game;
};

export const BullpenModeInfo = ({ game }: BullpenModeInfoProps) => {
  // Backend returns camelCase (homeLineup, playerName) but types expect snake_case
  const gameWithBackendFormat = game as unknown as {
    lineups?: {
      homeLineup?: Array<{ playerName?: string }>;
    };
  };

  const bullpenPitcher =
    gameWithBackendFormat.lineups?.homeLineup?.[0]?.playerName;

  const startTime = getEventTimes(game).startTime;

  return (
    <div className="mt-5 mb-5 w-full space-y-2">
      <div className="flex flex-col">
        <span className="font-bold text-text-light">Bullpen Pitcher:</span>
        <span className="text-text-light mb-2">{bullpenPitcher || "—"}</span>
      </div>

      <div className="flex flex-row gap-2">
        <span className="font-bold text-text-light">Started at:</span>
        <span className="text-text-light">
          {formatGameStartTime(Number(startTime))}
        </span>
      </div>
    </div>
  );
};
